import { getLabel } from "@/components/General/LanguageSelector/partials/label.component";
import { setLanguageCookie } from "@/services/cookie.service";
import { Config } from "@/utils/config.utils";
import { useAlgoliaQueryHook } from "@/utils/hooks/algolia/useAlgoliaQuery.hook";
import { useSharedWishListId } from "@/utils/hooks/useSharedWishlistId.hook";
import "./toggle.scss";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useIsClientSide } from "@/utils/hooks/isClient.hook";

type Props = {
    variant?: string;
};

const LanguageToggleSelector = ({ variant }: Props) => {
    const { t } = useGranite();

    const clientSide = useIsClientSide();

    const algoliaQuery = useAlgoliaQueryHook();
    const sharedWishListId = useSharedWishListId();

    const language = Config.languages.find(
        (language) => language.locale !== Config.general.locale
    );

    const handleOnClick = () => {
        if (!language) return;

        setLanguageCookie(language["language-code"]);
    };

    if (!clientSide) return null;
    if (!language) return null;

    return (
        <div className={"h-100 d-flex flex-column justify-content-center"}>
            <a
                className="language-selector__toggle"
                href={`${language.url}${algoliaQuery}${sharedWishListId}`}
                onClick={handleOnClick}
            >
                {getLabel({
                    language: language,
                    variant: variant,
                    t: t
                })}
            </a>
        </div>
    );
};

export default LanguageToggleSelector;
